class MailCreator {
  constructor(el) {
    this.dom = {el: el};

    this.init();
  }

  init() {
    this.dom.el.href = 'mailto:' + encodeURI('press' + '@' + 'career-tasu.com');
  }
}

export default MailCreator